import React, { useMemo } from 'react';

const DemoWatermark = ({ email }) => {
  const watermarkBg = useMemo(() => {
    const date = new Date().toISOString().split('T')[0];
    const text = `${email}  |  ${date}`;
    const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="500" height="200"><text transform="rotate(-30 250 100)" x="250" y="100" font-size="13" fill="white" opacity="0.07" text-anchor="middle" font-family="monospace">${escaped}</text></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
  }, [email]);

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 9999,
        backgroundImage: watermarkBg,
        backgroundRepeat: 'repeat',
      }}
    />
  );
};

export default DemoWatermark;
